'use client';

import StringValidator from './string.js';
import NumberValidator from './number.js';
import DateValidator from './date.js';
import ArrayValidator from './array.js';

function validation(translate) {
    return {
        string: function () { return new StringValidator(translate); },
        number: function () { return new NumberValidator(translate); },
        date: function () { return new DateValidator(translate); },
        array: function () { return new ArrayValidator(translate); }
    };
}

export { validation as default };
//# sourceMappingURL=index.js.map
